import React from 'react';
import './ExchangePolicy.css';

import imgss from "../../assets/images/kidss.avif";
import Footer from '../../components/Footer/Footer';
const ExchangePolicy = () => {
    return (
        <>
        
                               <img src={imgss} alt="" className='abtimg cuim' />
        <div className="exchange-policy-container">
            {/* Header Section */}
            <div className="page-header">
                <div className="container">
                    <h1 className="page-title">Return & Exchange Policy</h1>
                    
                </div>
            </div>




            {/* Main Content */}
            <div className="main-content">
                <div className="container">
                    {/* Policy Introduction */}
                    <div className="policy-intro">
                        <h2 className="section-heading">Swarna Prakash Jewellers Buy-Back and Exchange Policy</h2>
                        <p className="effective-date">(Applicable w.e.f. June 2025)</p>
                        <p className="intro-text">
                            This document outlines our comprehensive return and exchange policy for all jewelry categories.
                            Please read the terms carefully before making any purchase.
                        </p>
                    </div>


                    {/* Diamond Jewellery Section */}
                    <div className="policy-section">
                        <h3 className="subsection-heading">i) For Diamond Jewellery</h3>

                        <div className="policy-cards-container">
                            <div className="policy-card">
                                <h4 className="policy-item-title">Diamond for Diamond Exchange:</h4>
                                <p className="policy-description">
                                    <strong>80%</strong> of the <strong>diamond value</strong> as per the original bill.
                                    The <strong>gold value</strong> in the ornament will be considered as per Swarna Prakash Jewellers'
                                    daily prevailing board rate.
                                </p>
                            </div>


                            <div className="policy-card">
                                <h4 className="policy-item-title">Diamond for Gold Exchange:</h4>
                                <p className="policy-description">
                                    <strong>70%</strong> of the <strong>diamond value</strong> as per the original bill.
                                    The <strong>gold value</strong> in the ornament will be considered as per Swarna Prakash Jewellers'
                                    daily prevailing board rate.
                                </p>
                            </div>


                            <div className="policy-card">
                                <h4 className="policy-item-title">For Cash:</h4>
                                <p className="policy-description">
                                    We currently do not offer cash buy-back for diamond jewellery.
                                </p>
                            </div>
                        </div>


                        <div className="solitaire-section">
                            <h4 className="policy-item-title">Solitaire Diamonds (above 30 cents):</h4>
                            <div className="policy-cards-container">
                                <div className="policy-card">
                                    <h5 className="policy-subitem-title">Exchange for Diamond:</h5>
                                    <p className="policy-description">80% of the diamond value as per the original bill.</p>
                                </div>
                                <div className="policy-card">
                                    <h5 className="policy-subitem-title">Exchange for Gold:</h5>
                                    <p className="policy-description">70% of the diamond value as per the original bill.</p>
                                </div>
                            </div>
                            <p className="note">
                                <em>Note: Buy-back of Solitaire Diamonds above 30 cents are subject to market conditions.
                                    Exchange values are indicative/tentative only.</em>
                            </p>
                        </div>


                        <div className="important-notes">
                            <h5 className="notes-heading">Important Notes for Diamond Jewellery:</h5>
                            <ol className="notes-list">
                                <li>The gold net weight in the ornament will be bought back as per Swarna Prakash Jewellers' daily running board rate. Making charges and taxes will not be reimbursed.</li>
                                <li>Swarna Prakash Jewellers does not purchase or exchange diamonds or diamond jewellery bought from other jewellers.</li>
                                <li>Should Swarna Prakash Jewellers ornaments be presented for exchange/buy-back without the original bill copy, Swarna Prakash Jewellers reserves the right to deny the transaction or vary the exchange/buy-back policy.</li>
                                <li>Diamond ornaments will be inspected for damages or loss during buy-back/exchange, and applicable deductions will be applied.</li>
                            </ol>
                        </div>
                    </div>


                    {/* Gold Jewellery Section */}
                    <div className="policy-section">
                        <h3 className="subsection-heading">ii) For Gold Jewellery</h3>

                        <div className="policy-cards-container">
                            <div className="policy-card">
                                <h4 className="policy-item-title">Swarna Prakash Jewellers 916 Gold Jewellery for Exchange:</h4>
                                <p className="policy-description">100% of the prevailing board value.</p>
                            </div>


                            <div className="policy-card">
                                <h4 className="policy-item-title">Other Jewellers' 916 Gold Jewellery for Exchange:</h4>
                                <p className="policy-description">100% of the prevailing board value.</p>
                            </div>


                            <div className="policy-card">
                                <h4 className="policy-item-title">Gold Jewellery lower than 916 purity:</h4>
                                <p className="policy-description">
                                    Exchange value will be as per the prevailing rate policy of the store, determined after purity testing.
                                </p>
                            </div>
                        </div>


                        <div className="policy-cards-container">
                            <div className="policy-card">
                                <h4 className="policy-item-title">Cash Buy-Back on Swarna Prakash Jewellers 916 Gold Jewellery:</h4>
                                <p className="policy-description">Board rate less 3%.</p>
                            </div>


                            <div className="policy-card">
                                <h4 className="policy-item-title">For Cash Buy-Back on Other Jewellers' Gold Jewellery:</h4>
                                <p className="policy-description">
                                    We do not offer cash buy-back for gold jewellery purchased from other jewellers.
                                </p>
                            </div>
                        </div>


                        <div className="important-notes">
                            <h5 className="notes-heading">Important Notes for Gold Jewellery:</h5>
                            <ol className="notes-list">
                                <li>Making charges and taxes will not be reimbursed.</li>
                                <li>If Swarna Prakash Jewellers ornaments are presented for exchange or buy-back without the original bill copy, Swarna Prakash Jewellers reserves the right to deny the transaction or vary the buy-back and exchange rates from the above policy.</li>
                                <li>Exchange/Buy-back will be for the net weight of the ornaments only. The net weight mentioned in the bill will be validated, and items will be inspected for damages.</li>
                            </ol>
                        </div>
                    </div>


                    {/* Gemstone Jewellery Section */}
                    <div className="policy-section">
                        <h3 className="subsection-heading">iii) For Gemstone Jewellery</h3>

                        <h4 className="policy-item-title">Precious and Semi-Precious Gemstones, Synthetic/American Diamonds:</h4>
                        <p className="policy-description">
                            There is no exchange value for these components. Only the gold or diamond content (if applicable)
                            will be considered for buy-back/exchange as per the relevant policies above.
                        </p>
                    </div>


                    {/* Silver Jewellery Section */}
                    <div className="policy-section">
                        <h3 className="subsection-heading">iv) For Silver Jewellery/Articles</h3>

                        <div className="policy-cards-container">
                            <div className="policy-card">
                                <h4 className="policy-item-title">For Exchange (Swarna Prakash Jewellers Articles/Jewellery):</h4>
                                <p className="policy-description">
                                    (% purity - 12) * board rate (999) without Making Charges.
                                </p>
                            </div>


                            <div className="policy-card">
                                <h4 className="policy-item-title">For Exchange (Other Silver Articles/Jewellery):</h4>
                                <p className="policy-description">Based on prevailing store exchange rate policy.</p>
                            </div>


                            <div className="policy-card">
                                <h4 className="policy-item-title">For Cash:</h4>
                                <p className="policy-description">
                                    We currently do not offer cash buy-back for silver jewellery or articles.
                                </p>
                            </div>
                        </div>


                        <div className="important-notes">
                            <h5 className="notes-heading">Important Notes for Silver Jewellery:</h5>
                            <ol className="notes-list">
                                <li>Ornaments will be inspected for damages, and the net weight mentioned in the bill (if available) will be validated.</li>
                                <li>If the original bill is not presented, Swarna Prakash Jewellers reserves the right to vary the buy-back or exchange policy.</li>
                            </ol>
                        </div>
                    </div>


                    {/* Footer Note */}
                    <div className="policy-footer">
                        <div className="footer-note">
                            <p>
                                This document has been prepared for products listed on avnii.in and available in our stores.
                                For categories not specifically mentioned here, please inquire with our sales executive at the
                                time of your visit or contact our customer service.
                            </p>
                            <p className="disclaimer">
                                <strong>Swarna Prakash Jewellers reserves the right to vary the policies mentioned above without prior notice.</strong>
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
   <Footer />
        </>
    );
};


export default ExchangePolicy;